import "./Achievements.css";
import {useEffect} from "react";

const Achievements = () => {

    useEffect(() => {
        const counters = document.querySelectorAll(".counter")

        counters.forEach(counter => {
            counter.innerText = "0";

            const updateCounter = () => {
                const target = +counter.getAttribute("data-target");
                const c = +counter.innerText;

                const increment = target / 200;

                if(c<target){
                    counter.innerText = `${Math.ceil(c + increment)}`
                    setTimeout(updateCounter, 30);
                    } else{
                    counter.innerText = target;
                }
        }
        updateCounter()
        })
    });


    return ( 
        <div className="numbers">
            <div className="counter-container">
                <div className="counter" data-target="86"></div>
                <span>Projects</span>
            </div>

            <div className="counter-container">
                <div className="counter" data-target="45"></div>
                <span>Clients</span>
            </div>

            <div className="counter-container">
                <div className="counter" data-target="250"></div>
                <span>Members</span>
            </div>
        </div>
     );
}
 
export default Achievements;